/**
 * Login page — OAuth links in view; session redirect handled server-side on GET /.
 */
const params = new URLSearchParams(window.location.search);
if (params.has('auth')) {
  window.history.replaceState(null, '', '/');
}
